import React from 'react'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import logo from '../../Assests/a.jpg'

export default function Header() {
    const [burgerToggle, setBurgerToggle] = useState(false);

    return (
        <div className='relative w-full'>
            <div className='absolute w-full top-0 z-20 px-12 lg:py-4' >
                <nav className='flex justify-between py-4 '>
                    <div className=' flex gap-2 items-center'>
                        <img src={logo} alt="" className='w-6 h-6 lg:w-12 lg:h-12 rounded-full' />
                        <h4 className=' md:text-xl text-xs font-bold uppercase text-white'>Abdullah</h4>
                    </div>
                    <div className='hidden lg:block '>
                        <ul className=' flex space-x-4 font-bold uppercase drop-shadow text-white'>
                            <Link to="/"><li className=' rounded-lg shadow cursor-pointer hover:text-green-500 p-2 shadow-white'>Home</li></Link>
                            <a href="#about-me"><li className=' rounded-lg shadow cursor-pointer hover:text-green-500 p-2 shadow-white'>About Me</li></a>
                            <a href="#contact-me"> <li className=' rounded-lg  shadow cursor-pointer hover:text-green-500 p-2 shadow-white'>Contact Me</li></a>
                            <Link to='/blog'><li className=' rounded-lg  shadow cursor-pointer hover:text-green-500 p-2 shadow-white'>Blog</li></Link>
                            <a target='_blank' href='https://drive.google.com/uc?id=14mnZ34uSc0QN8OsloSCQJvIICI34kXRq&export=download'
                                className=' rounded-lg  shadow cursor-pointer hover:text-green-500 p-2 shadow-white text-red-600'>Download Resume</a>
                        </ul>
                    </div>
                    <div onClick={() => setBurgerToggle(!burgerToggle)} className={`flex lg:hidden cursor-pointer flex-col text-white`}>
                        <div className={`h-px w-4 mb-1 ${burgerToggle ? 'bg-green-500' : 'bg-white'}`}></div>
                        <div className={`h-px w-4 mb-1 ${burgerToggle ? 'bg-green-500' : 'bg-white'}`}></div>
                        <div className={`h-px w-4 mb-1 ${burgerToggle ? 'bg-green-500' : 'bg-white'}`}></div>
                    </div>
                    <div className={`${burgerToggle ? 'top-8 right-0 bg-black w-full text-center py-4 rounded' : 'right-0 -top-72'} absolute lg:hidden duration-300 z-50`}>
                        <ul className=' flex flex-col space-y-2 font-bold uppercase drop-shadow text-white'>
                            <Link onClick={() => setBurgerToggle(!burgerToggle)} to="/"><li className=' rounded-lg  cursor-pointer inline-block hover:text-green-500 p-2 shadow-white'>Home</li></Link>

                            <a onClick={() => setBurgerToggle(!burgerToggle)} href="#about-me"><li className=' rounded-lg inline-block cursor-pointer hover:text-green-500 p-2 shadow-white'>About Me</li></a>
                            <a onClick={() => setBurgerToggle(!burgerToggle)} href="#contact-me"> <li className=' rounded-lg inline-block cursor-pointer hover:text-green-500 p-2 shadow-white'>Contact Me</li></a>
                            <Link onClick={() => setBurgerToggle(!burgerToggle)} to='/blog'><li className=' rounded-lg   cursor-pointer inline-block hover:text-green-500 p-2 shadow-white'>Blog</li></Link>

                            <a onClick={() => setBurgerToggle(!burgerToggle)} target='_blank' href='https://drive.google.com/uc?id=14mnZ34uSc0QN8OsloSCQJvIICI34kXRq&export=download'
                                className='rounded-lg  cursor-pointer hover:text-green-500 p-2 shadow-white text-red-600'><li className=' border inline-block p-2 rounded-lg shadow-sm shadow-white'>Download Resume</li></a>

                        </ul>
                    </div>
                </nav>
            </div>
        </div>
    )
}
